module.exports = __webpack_public_path__ + "img/shoulders.16276049.png";